const OrganisationStatusEnum = Object.freeze({
    UNVERIFIED: 'UNVERIFIED',
    ACTIVE: 'ACTIVE',
    SUSPENDED: 'SUSPENDED',
    INACTIVE: 'INACTIVE'
});

export default OrganisationStatusEnum;
